import React, { useEffect, useState } from 'react'
import { Layout, Table, Card, Button, Spin, Tooltip } from 'antd'
import moment from 'moment'
import apiRequest from '../hooks/ApiRequest'
import FinanceManagement from './FinanceManagement'
import Layouts from '../components/Layouts'
import TransactionHistoryModal from './TransactionHistoryModal'
import { UploadOutlined, HistoryOutlined } from '@ant-design/icons'

const { Content } = Layout

const PolicyTable = () => {
  const [policies, setPolicies] = useState([])
  const [loading, setLoading] = useState(false)
  const [showFinanceModal, setShowFinanceModal] = useState(false)
  const [selectedPolicyDetail, setSelectedPolicyDetail] = useState(null)
  const [showTransactionModal, setShowTransactionModal] = useState(false)
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null)

  useEffect(() => {
    const fetchPolicies = async () => {
      setLoading(true)
      try {
        const res = await apiRequest(`${process.env.REACT_APP_BASE_URL}/Policy/GetPoliciesByTransactionStatus/get-policies-transaction-status`, 'GET')
        if (res.success && Array.isArray(res.data)) {
          setPolicies(res.data)
        } else {
          console.error('Failed to fetch policies')
        }
      } catch (err) {
        console.error('Error fetching policies:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchPolicies()
  }, [])

  const handleAction = (record) => {
    setSelectedPolicyDetail(record)
    setShowFinanceModal(true)
  }

  const openTransactionHistory = (policyNumber) => {
    setSelectedPolicyNumber(policyNumber)
    setShowTransactionModal(true)
  }

  const handleFinanceUploadSuccess = () => {
    // refresh policies if needed after successful upload
    setShowFinanceModal(false)
  }

  const columns = [
    {
      key: '11',
      title: 'Customer Name',
      dataIndex: 'customerName',
    },
    {
      key: '21',
      title: 'Policy Number',
      dataIndex: 'policyNumber',
    },
    {
      key: '51',
      title: 'Premium',
      dataIndex: 'totalPremium',
      render: val => parseFloat(val).toFixed(2),
    },
    {
      key: '61',
      title: 'Status',
      dataIndex: 'paymentStatus',
    },
    {
      key: '71',
      title: 'Created Date',
      dataIndex: 'createddate',
      render: date => moment(date).format('YYYY-MM-DD'),
    },
    {
      key: '81',
      title: 'Action',
      render: (_, record) => (
        <>
          <Tooltip title="Upload Proof">
            <Button
              type="primary"
              shape="circle"
              onClick={() => handleAction(record)}
              style={{ marginRight: 8 }}
            >
              <UploadOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="View History">
            <Button
              shape="circle"
              onClick={() => openTransactionHistory(record.policyNumber)}
            >
              <HistoryOutlined />
            </Button>
          </Tooltip>
        </>
      ),
    },
  ]

  return (
    <Layouts style={{ padding: '24px' }}>
      <Content>
        <Card title="Policies">
          <Spin spinning={loading}>
            <Table
              dataSource={policies}
              columns={columns}
              rowKey="policyid"
              pagination={{ pageSize: 10 }}
            />
          </Spin>
        </Card>

        {showFinanceModal && (
          <FinanceManagement
            visible={showFinanceModal}
            onCancel={() => setShowFinanceModal(false)}
            policydetail={selectedPolicyDetail}
            onSuccess={handleFinanceUploadSuccess}
          />
        )}
        {showTransactionModal && (
          <TransactionHistoryModal
            visible={showTransactionModal}
            onCancel={() => setShowTransactionModal(false)}
            policyNumber={selectedPolicyNumber}
          />
        )}

      </Content>
    </Layouts>
  )
}

export default PolicyTable
